import {
  DateRangeTimezoneValue,
  DateRangeValue,
} from 'shared/mui/DatePicker/DateTimeRangeTimezonePicker/DateTimeRangeTimezonePicker';
import { FilterFields } from 'shared/mui/Filter/FilterFields/FilterFields';

import { useOrdersReportFilterFields } from './hooks/useOrdersReportFilterFields';

export type OrdersReportFilterFormValues = {
  id: string;
  merchantReference: string;
  providerReferenceId: string;
  transaction: string;
  company: string;
  merchant: string;
  provider: string;
  merchantAccount: string[];
  gateway: string[];
  createdAt: {
    gte: number;
    lte: number;
  };
  transactions: {
    createdAt: {
      gte: Date;
      lte: Date;
    };
  };
  appliedDate: DateRangeValue;
  transactionsAppliedDate: DateRangeValue;
  direction: string;
  timezone: DateRangeTimezoneValue;
  currency: string[];
  method: string[];
};

export const OrdersReportListFilter: React.FC = () => {
  const fields = useOrdersReportFilterFields();

  return <FilterFields fields={fields} />;
};
